import React from "react";
import styles from "./ArtYerkirCard.module.scss";

const ArtYerkirCard = ({ item }) => {
  return (
    <div className={styles.card} onClick={() => console.log("Card clicked.")}>
      <h2 className={styles.type}>{item.type}</h2>
      <div className={styles.title}>{item.title}</div>
      <div className={styles.date}>{item.date}</div>
      <p className={styles.description}>{item.description}</p>
      <div className={styles.image}>
        <img src={item.image} alt={item.title} />
      </div>
    </div>
  );
};

export default ArtYerkirCard;
